import { useGatewayQuery } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { useReadCalendarColor } from "@clockwise/web-commons/src/util/CalendarColorsContext";
import React from "react";
import { EventElementsWrap } from "../atoms/EventElementsWrap";
import { CalendarInfoDocument } from "./__generated__/CalendarInfo.v2.generated";

export function ECCalendarInfo({ calendarId }: { calendarId: string }) {
  const calendarColor = useReadCalendarColor(calendarId);

  const { data, loading } = useGatewayQuery(CalendarInfoDocument, {
    variables: { id: calendarId },
    fetchPolicy: "cache-first",
  });
  const calendarName = loading ? "" : data?.calendar?.displayName ?? calendarId;

  return (
    <EventElementsWrap name="calendar">
      <div className="cw-flex cw-items-center cw-gap-1">
        <div
          className="cw-w-3 cw-h-3 cw-rounded"
          style={{
            backgroundColor: calendarColor?.bg_Emphasis,
          }}
        />
        <span className="cw-body-sm cw-font-medium">{calendarName}</span>
      </div>
    </EventElementsWrap>
  );
}
